import React, { useState } from "react";
import HTMLReactParser from 'html-react-parser';
import "../KeywordAccordion/KeywordAccordion.scss"; 
import iconArrowDown from "../../../images/downArrow.svg";
import iconArrowUp from "../../../images/upArrow.svg";

const KeywordContent = ({ title = "Title", content }) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="keyword-container">
            <hr className="hr-keyword" />
            <div className="keyword-title" onClick={() => setIsOpen(!isOpen)}>
                <h2 className="heading">{title}</h2>
                <img
                    src={isOpen ? iconArrowUp : iconArrowDown}
                    alt="Toggle"
                    className="keyword-toggle"
                />
            </div>
                <div className={`keyword-content ${isOpen ? "d-block" : "d-none"}`}>
                    {content && content.length > 0 ?
                    HTMLReactParser(content.replace(/<br\s*\/?>/gi, '')) : null}
                </div>
        </div>
    );
};

export default KeywordContent;
